import React from 'react';
import Modal from 'react-bootstrap/Modal';
import TripCard from '../../trip-card';
import { useTrip } from '../../contexts/trip-context';

interface TripInfoModalProps {
  show: boolean;
  handleClose: () => void;
}

const TripInfoModal: React.FC<TripInfoModalProps> = ({ show, handleClose }) => {
  const { trip } = useTrip();

  if (!trip) return null;

  const tripCardProps = {
    id: trip.id || '',
    title: trip.title || '',
    description: trip.description || '',
    createdBy: trip.createdByUsername || '',
    createdAt: trip.createdAt?.toString() || '',
    imgUrl: {
      src: trip.imageUrl || '',
      alt: trip.title || ''
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      style={{ maxWidth: '800px', margin: 'auto' }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Trip Information</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          height: '800px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px'
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            pointerEvents: 'none',
            transform: 'scale(1.8)',
            transformOrigin: 'center',
            width: '300px'
          }}
        >
          <TripCard {...tripCardProps} />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TripInfoModal;
